import { isEmpty } from 'Data/format.js'

export function getPrompt(value) {
  return value === 'responsiblePersonContactDetails'
    ? 'What is the email of the responsible person?'
    : "What is the patient's email address?"
}

export function markAsInvalid(isValid, value) {
  return isEmpty(value) || isValid
}
